import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";

export async function postRefundPayment<T>(body: T) {
  return axiosFetch.post("/api/CreditCardPayment/RefundPayment", body);
}
